import StyleSheet from './stylesheet';

const defaultConfig = {
  level: 0,
  visibility: true,
  selfContained: false,
  highlighters: [
    { hlColor: '#000' },
    { hlColor: '#111' },
    { hlColor: '#222' },
  ],
};

class Layer {
  constructor(props) {
    this.generateStyle = this.generateStyle.bind(this);
    this.getVisibleColor = this.getVisibleColor.bind(this);
    this.hideWhiteText = this.hideWhiteText.bind(this);
    this.renderHighlighter = this.renderHighlighter.bind(this);
    this.init = this.init.bind(this);
    this.update = this.update.bind(this);
    this.render = this.render.bind(this);

    this.stylesheet = new StyleSheet('kjuicer-style');
    this.sheet = this.stylesheet.sheet;
    if (props) {
      this.init(props);
    }
  }

  init(props = {}) {
    document.head.appendChild(this.stylesheet.html);
    this.sheet = this.stylesheet.sheet;
    this.html = this.stylesheet.html;
    this.conf = { ...defaultConfig, ...props };
    this.render();
  }

  generateStyle() {
    const style = this.conf.highlighters.reduce(this.renderHighlighter, {});
    return this.hideWhiteText(style);
  }

  get level() {
    return this.conf.level;
  }

  get highlighters() {
    return this.conf.highlighters;
  }

  renderHighlighter(style, hl, lvl) {
    if (lvl + 1 < this.conf.level) {
      return {
        ...style,
        [`[data-level="${lvl + 1}"]`]: { display: 'none' },
      };
    }
    return {
      ...style,
      [`[data-level="${lvl + 1}"]`]: false,
      [`mark[data-level="${lvl + 1}"]`]: { 'background-color': `${this.getVisibleColor(hl)} !important` },
    };
  }

  getVisibleColor(hl) {
    return (this.conf.visibility) ? hl.hlColor : 'transparent';
  }

  hideWhiteText(style) {
    if (this.conf.level > 0) {
      return {
        ...style,
        '.block-hidden': { display: 'none' },
        '.text-hidden': { display: 'none' },
      };
    }
    return {
      ...style,
      '.block-hidden': false,
      '.text-hidden': false,
    };
  }

  clearHighlighters(style) {
    let removeRules = [];
    if (this.conf.prev && (this.conf.prev.highlighters.length !== this.conf.highlighters.length)) {
      removeRules = this.conf.prev.highlighters.map((hl, i) => {
        if (!this.conf.highlighters[i]) {
          return { [`mark[data-level="${i + 1}"]`]: false };
        }
        return null;
      }).filter(el => el);
    }
    return removeRules.reduce((prev, current) => ({ ...prev, ...current }), style);
  }

  update(props) {
    this.conf = { ...this.conf, ...props };
    this.render();
  }

  render() {
    let style = this.generateStyle();
    style = this.clearHighlighters(style);
    this.stylesheet.update(style);
  }
}

export default Layer;
